import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import _ from "lodash";
import Loading from "../Loading";
import { useWorkspaces } from "../Rbac/RbacQueries";
import { DialogProps } from "./useDialogs";

function WorkspacePromptingDialog({
  payload,
  open,
  onClose,
}: DialogProps<{
  workspaces: string[];
  onChose: (workspace: string) => void;
}>) {
  const { data, isLoading, isError } = useWorkspaces();
  const completeWorkspaces = _.filter(data, (workspace) =>
    payload.workspaces.includes(workspace._id)
  );

  function getContent() {
    if (isLoading) {
      return <Loading />;
    } else if (isError) {
      return (
        <Alert variant="outlined" severity="error">
          Une erreur est survenue
        </Alert>
      );
    } else {
      return (
        <List>
          {completeWorkspaces.map((workspace) => (
            <ListItem disablePadding key={workspace._id}>
              <ListItemButton
                onClick={() => {
                  payload.onChose(workspace._id);
                  onClose();
                }}
              >
                <ListItemText primary={workspace.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      );
    }
  }
  return (
    <Dialog onClose={() => onClose()} open={open}>
      <DialogTitle>
        Choisissez un espace de travail dans lequel créer cette ressource
      </DialogTitle>
      <DialogContent>{getContent()}</DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
      </DialogActions>
    </Dialog>
  );
}

export default WorkspacePromptingDialog;
